<template lang="pug">
div
    v-dialog(v-model='show' persistent max-width='900px')
        v-card
            v-card-title.d-flex.align-center.justify-center
                | {{ dialogTitle }}
            v-card-text
                AlertRulesIndex(
                    v-if='currentView === "index"'
                    @create='startCreate'
                    @edit='startEdit'
                    @destroy='destroyRule'
                    :rules='rules'
                    :is-loading='isLoading'
                )
                AlertRulesForm(
                    v-else
                    :mode='currentView'
                    :rule='selectedRule'
                    :rules='rules'
                    @save='handleSave'
                    @cancel='returnToIndex'
                )
            v-card-actions(v-if='currentView === "index"')
                v-spacer
                v-btn(text @click='closeDialog') Close
</template>

<script>
import Vue from 'vue';

// Components
import AlertRulesIndex from '@/components/dashboards/big_board/alert_rules/alert_rules_index.vue';
import AlertRulesForm from '@/components/dashboards/big_board/alert_rules/alert_rules_form.vue';

// Data 
import {CreateRule, UpdateRule, DestroyRule} from '@/data';

export default Vue.extend({
    data() {
        return {
            currentView: 'index',
            selectedRule: null,
            isLoading: false,
        }
    },
    methods: {
        closeDialog(){
            this.$emit('input', false)
        }, 
        createRule(formData) {
            if (!(formData)) {
                return;
            }

            const options = {
                purpose: 'big_board_account', 
                rule_action: formData?.rule_action || null,
                metric: formData?.metric || 0,
                metric_unit: formData?.metric_unit || null,
                display_color: formData?.display_color || null,
            }

            this.isLoading = true;
            CreateRule(options).then((response) => {
                if (response?.Data?.rule?.rule_id > 0 ) {
                    this.reloadRules()
                    this.showSnackbar('success', 'Alert rule created successfully')
                } else {
                    let errorMessage = response?.Error || 'Unable to create alert rule'
                    this.showSnackbar('error', errorMessage)
                }
                this.isLoading = false;
            })
        },
        startCreate() {
            this.selectedRule = null
            this.currentView = 'create'
        },
        startEdit(rule) {
            this.selectedRule = rule
            this.currentView = 'edit'
        },
        async handleSave(formData) {
            if (this.currentView === 'create') {
                this.createRule(formData)
            } else {
                this.updateRule(formData)
            }
            this.returnToIndex()
        },
        destroyRule(rule) {
            this.isLoading = true;
            DestroyRule(rule.rule_id).then((response) => {
                if (response?.Data?.ok) {
                    this.reloadRules()
                    this.showSnackbar('success', 'Alert rule deleted successfully')
                } else {
                    let errorMessage = response?.Error || 'Unable to delete alert rule'
                    this.showSnackbar('error', errorMessage)
                }
                this.isLoading = false;
            })
        },
        updateRule(formData) {
            if (!(formData)) {
                return;
            }

            const id = formData?.rule_id;
            if (!id) {
                return;
            }

            const options = {
                rule_id: formData?.rule_id || null,
                rule_action: formData?.rule_action || null,
                metric: formData?.metric || 0,
                metric_unit: formData?.metric_unit || null,
                display_color: formData?.display_color || null,
            }

            this.isLoading = true;
            UpdateRule(id, options).then((response) => {
                if (response?.Data?.rule?.rule_id > 0 ) {
                    this.reloadRules()
                    this.showSnackbar('success', 'Alert rule created successfully')
                } else {
                    let errorMessage = response?.Error || 'Unable to update alert rule'
                    this.showSnackbar('error', errorMessage)
                }
                this.isLoading = false;
            })
        },
        returnToIndex() {
            this.currentView = 'index'
            this.selectedRule = null
        },
        reloadRules() {
            this.$emit('reload-rules')
        },
    },
    computed: {
        show: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        dialogTitle() {
            switch (this.currentView) {
                case 'create':
                    return 'Create Alert Rule'
                case 'edit':
                    return 'Edit Alert Rule'
                default:
                    return 'Alert Rules'
            }
        }
    },

    components: {
        AlertRulesIndex,
        AlertRulesForm
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        showSnackbar: Function,
        rules: Array, 
        isLoadingRules: Boolean,
    },

    watch: {
        show(newVal) {
            if (!newVal) {
                this.returnToIndex()
            }
        },
        isLoadingRules: {
            immediate: true,
            handler(newVal) {
                this.isLoading = newVal
            }
        }
    },

    created() {
    },

    mounted() {
    },

    destroyed() {
    }
})
</script>

<style lang="scss" scoped>

</style>